<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({ name: 'RegionalManagerUsersAgentsCreate' }),
                    showDialog(),
                  ]
                "
              >
                <v-icon small left>mdi-plus</v-icon>
                {{ $t("newAgent") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left> mdi-printer </v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('labelSearch')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <!-- Column ID -->
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
          </template>
          <!-- Column Name agent-->
          <template v-slot:item.name_agent="{ item }">
            <a
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  'regionalManager/agents/getAgent'
                )
              "
            >
              <v-icon color="blue" x-small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
          </template>

          <!-- Column  -->
          <template v-slot:item.status="{ item }">
            <v-icon
              v-if="item.status == 8"
              size="16"
              color="red"
            >
              mdi-circle
            </v-icon>
            <v-icon :color="handleColorStatus(item.status)" size="16">
              mdi-circle
            </v-icon>
          </template>

          <template v-slot:item.data_cadastro="{ item }">
            <div class="caption">
              {{ dateFormat(item.data_cadastro) }}
            </div>
          </template>

          <!-- Column  -->
          <template v-slot:item.limit_retention="{ item }">
            <span class="caption">
              {{ unlimited(item.limit_retention) }}
            </span>
          </template>

          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_local,
                  'regionalManager/locals/getLocal'
                )
              "
            >
              <v-icon color="green" x-small>mdi-account-multiple</v-icon>
              {{ item.name_local }}
            </a>
          </template>

          <!-- Column Action -->
          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="item.status == 1 || item.status == 0"
                    v-bind="attrs"
                    v-on="on"
                    small
                    v-on:click="
                      $router.push({
                        name: 'RegionalManagerBetHistoricAgent',
                        params: {
                          id_local: item.id_local,
                          id_agent: item.id,
                        },
                      })
                    "
                  >
                    <v-icon>mdi-ticket-confirmation</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("viewBets") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="item.status == 1 || item.status == 0"
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      $router.push({
                        name: 'RegionalManagerFinancialApuration',
                        query: {
                          id_agent: item.id,
                          id_local: item.id_local,
                        },
                      })
                    "
                  >
                    <!-- <v-icon>mdi-cash-usd-outline</v-icon> -->
                    <v-icon>mdi-currency-usd</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("accounting") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="item.status == 1 || item.status == 0"
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      $profile.showProfileDrawer(
                        item.id,
                        'regionalManager/agents/getAgent'
                      )
                    "
                  >
                    <v-icon size="24">mdi-account-circle</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("profile") }}</span>
              </v-tooltip>
              <!-- Esconder o Editar se o Status for pendente(2) -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name: 'RegionalManagerUsersAgentsEdit',
                          params: { id: item.id },
                        }),
                        showDialog(),
                      ]
                    "
                  >
                    <v-icon size="24">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "regional-manager-users-agents-list",
  components: {
    HeaderPrint,
  },

  data: () => ({
    items: [],
    search: "",

    actions: "",
  }),
  computed: mapState({
    refresh() {
      return this.$store.getters.getRefresh;
    },
    // ====================================================
    // Retrieve Values in Filters
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        { text: this.$t("idLabel"), value: "id" },
        { text: this.$t("statusLabel"), value: "status" },
        { text: this.$t("name"), value: "name_agent" },
        { text: this.$t("labelLogin"), value: "login_agent" },
        { text: this.$t("retention"), value: "limit_retention" },
        { text: this.$t("localManagerName"), value: "name_local" },
        { text: this.$t("registrationDate"), value: "data_cadastro" },
        {
          text: this.$t("actionsLabel"),
          align: "center d-print-none",
          value: "action",
          sortable: false,
        },
      ];
    },
  }),
  watch: {
    saveFilters(val) {
      val && this.getAgentsList();
    },
    refresh(val) {
      val && this.getAgentsList();
      this.$store.commit("setRefresh", false);
    },
  },
  methods: {
    async getAgentsList() {
      this.search = "";
      const body = {
        status: this.status,
        id_local: this.id_local,
      };
      const request = await this.$request.post(
        "regionalManager/agents/list",
        body
      );
      if (request.length == 0) return;
      this.items = request.dados;
      // Handle Hide Column Actions (Hide - Status Pendente '2')
      // this.status == 2 ? this.hideActions() : this.openActions();
      this.openActions();
    },
    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
    // handle color status
    handleColorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },

    // Handle Hide Column Actions (Hide - Status Pendente '2')
    // hideActions() {
    //   this.headers.pop();
    // },
    openActions() {
      if (this.actions != "") {
        this.headers.push(this.actions);
        this.actions = "";
      }
    },
    unlimited(item) {
      return item >= 1000000 ? "Ilimitado" : item;
    },
    dateFormat: function(val) {
      var date = new Date(val.replace(" ", "T")).toLocaleString();
      return date;
    },
  },
};
</script>
